module.exports = __webpack_public_path__ + "img/file-chart-line.474a23a8.svg";